import React, { useEffect, useState } from 'react';
import { translate } from '../../services/translate';
import FormInput from '../../components/FormInput';
import MyPhoneInput from '../../components/MyPhoneInput';
import Toast from 'react-native-toast-message';
import { centralAPI } from '../../services/central-api';
import { ClientError } from '../../services/central-api/base-service';
import MyCpfInput from '../../components/MyCpfInput';
import CustomButton from '../../components/CustomButton';
import Container from '../../components/Container';
import Header from '../../components/Header';
import Card from '../../components/Card';


export default function Account() {
    const [isFormValid, setIsFormValid] = useState(false);

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [registry, setRegistry] = useState('');
    const [phone, setPhone] = useState('');
    const [warName, setWarName] = useState('');
    const [document, setDocument] = useState('');
    const [isDocumentInvalid, setIsDocumentInvalid] = useState(false);

    async function getOwnUser() {
        try {
            const user = await centralAPI.getOwnUser({ includeRole: false });
            setName(user.name);
            setEmail(user.email);
            setRegistry(user.registry);
            setPhone(user.phone);
            setWarName(user.warName || '');
            setDocument(user.document || '');
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getOwnUser();
    }, []);

    useEffect(() => {
        if (name === '') {
            return setIsFormValid(false);
        } else if (registry === '') {
            return setIsFormValid(false);
        } else if (phone === '' || phone.length < 10) {
            return setIsFormValid(false);
        } else if (isDocumentInvalid || document === '') {
            return setIsFormValid(false);
        }
        return setIsFormValid(true);
    }, [name, registry, phone, document, isDocumentInvalid]);

    async function save() {
        try {
            await centralAPI.updateOwnUser({
                phone,
                warName,
                document
            });

            Toast.show({
                type: 'sentinelxSuccess',
                text1: translate('ActionSuccessfully'),
            });
        } catch (err) {
            if (err instanceof ClientError) {
                return Toast.show({
                    type: 'sentinelxError',
                    text1: translate(err.message),
                });
            }
            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        }
    }

    return (
        <Container>
            <Header
                title={translate('account')}
                actions={<CustomButton
                    onPress={save}
                    disabled={!isFormValid}
                    text={translate('save')}
                />}
            />
            <Card style={{ rowGap: 15 }} scrollView={true}>
                <FormInput
                    label={translate('name')}
                    placeholder={translate('name')}
                    value={name}
                    onChangeText={setName}
                    invalid={(value: string) => {
                        return value === '';
                    }}
                    disabled={true}
                />
                <FormInput
                    label={translate('warName')}
                    placeholder={translate('warName')}
                    value={warName}
                    onChangeText={setWarName}
                    invalid={() => false}
                />
                <FormInput
                    label={translate('email')}
                    placeholder={translate('email')}
                    value={email}
                    onChangeText={setEmail}
                    invalid={() => false}
                    disabled={true}
                />
                <FormInput
                    label={translate('registration')}
                    placeholder={translate('registration')}
                    value={registry}
                    onChangeText={setRegistry}
                    invalid={(value: string) => {
                        return value === '';
                    }}
                    disabled={true}
                />
                <MyCpfInput
                    value={document}
                    onChangeText={setDocument}
                    isInvalid={isDocumentInvalid}
                    setIsInvalid={setIsDocumentInvalid} />
                <MyPhoneInput
                    label={translate('phone')}
                    placeholder={translate('phone')}
                    value={phone}
                    onChangeText={setPhone}
                    invalid={(value: string) => {
                        return value === '' || value.length < 10;
                    }}
                />
            </Card>
        </Container>
    );
}
